var map = {
	"./1080x1920_Greenpoint_ kacper_pirog.mp4": 5201,
	"./1080x1920_Greenpoint_kacper_pirog_02.mp4": 4151,
	"./1080x1920_barwa _1_storis.mp4": 4575,
	"./1080x1920_barwa _2_storis.mp4": 3520,
	"./1080x1920v2.mp4": 2788,
	"./filmik_4K_2160x3840 25fps.mp4": 291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9581;